<template>
    <div>
        
        <PipelineCard v-for="pipeline in pipelines"
                      :key="pipeline.id"
                      :pipeline="pipeline"
                      @click="onClick"
                      class="my-3"/>

    </div>
</template>

<script>
import utility from '@/mixins/utility'

import PipelineCard from '@/components/Pipeline/Card'

export default 
{
   name: 'Pipelines',

   mixins: [ utility ],

   components: 
   {
    PipelineCard
   },

   data: () => ({

   }),

   props: {
    pipelines:
    {
        type: Array,
        required: true
    }
   },

   computed: {},

   methods:
   {
    onClick(pipeline)
    {
        this.$emit('click', pipeline)
    }
   },

   mounted()
   {

   }
}
</script>